import { Routes, Route, Navigate } from 'react-router';
import { useAuth } from './providers/auth-provider';

// Layouts
import { DocsLayout } from './layouts/docs-layout';
import { AuthLayout } from './layouts/auth-layout';

// Auth Pages
import { LoginPage } from './pages/auth/login';

// Docs Pages
import { HomePage } from './pages/home';
import { DocsPage } from './pages/docs';
import { ArticlePage } from './pages/docs/[slug]';
import { SearchPage } from './pages/search';

// Protected Route Wrapper
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export function App() {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      {/* Protected Documentation Routes */}
      <Route
        element={
          <ProtectedRoute>
            <DocsLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<HomePage />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="/docs/:category" element={<DocsPage />} />
        <Route path="/docs/:category/:slug" element={<ArticlePage />} />
        <Route path="/search" element={<SearchPage />} />
      </Route>

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
